import ExcelJS from "exceljs";
import QRCode from "qrcode";

export const formatDate = (dateString) => {
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", options); // 'en-GB' for DD/MM/YYYY format
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${formattedDate} ${formattedTime}`; // format: October 29, 2024 11:32 AM
};

// CommonUtils.js

// Function to generate and download the vCard
export const handleSaveContact = (firstName, lastName, mobileNo) => {
  const vCardData = `BEGIN:VCARD
VERSION:3.0
FN:${firstName} ${lastName}
TEL;TYPE=VOICE,CELL:${mobileNo}
END:VCARD`;

  const blob = new Blob([vCardData], { type: "text/x-vcard" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${firstName}_${mobileNo}.vcf`;

  // Add a small delay to ensure the download works on mobile
  setTimeout(() => {
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, 100);
};

export const generateWhatsAppUrl = (phoneNumber, message) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
};

export const calculateAge = (timestamp) => {
  const birthDate = new Date(timestamp);
  const currentDate = new Date();

  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const monthDiff = currentDate.getMonth() - birthDate.getMonth();

  // Adjust age if the current date is before the birth date
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const whatsAppMessage = () => {
  const phoneNumber = "+923210111707";
  const message = "Hello, I want to order from Pharmacy.";
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  window.open(url, "_blank");
  return;
};

export const WhatsAppContact = (message) => {
  const phoneNumber = "+923210111707";
  const encodedMessage = encodeURIComponent(message);

  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
};


export const whatsAppLearnMore = () => {
  const phoneNumber = "+923210111707";
  const message = "Hello, I want to know About ApnaCard.";
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  window.open(url, "_blank");
  return;
};

export const exportCardsWithQR = async (cards, startNo, endNo) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Cards");

    // Define columns
    worksheet.columns = [
      { header: "Card No", key: "cardNo", width: 15 },
      { header: "URL", key: "scanUrl", width: 45 },
      { header: "QR Code", key: "qr", width: 20 },
    ];

    // Style the header row
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center", vertical: "middle" };
    headerRow.height = 25;

    // Style columns
    worksheet.getColumn(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    worksheet.getColumn(2).alignment = {
      horizontal: "left",
      vertical: "middle",
    };
    worksheet.getColumn(3).alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    for (const [index, card] of cards.entries()) {
      const rowNumber = index + 2; // Data starts from row 2
      const qrBase64 = await QRCode.toDataURL(card.scanUrl);

      // Add row
      const row = worksheet.addRow({
        cardNo: card.cardNo,
        scanUrl: card.scanUrl,
      });

      // Adjust height (just enough for QR)
      row.height = 90;
      row.alignment = { vertical: "middle", horizontal: "center" };

      // Add QR image (exactly inside this row)
      const imageId = workbook.addImage({
        base64: qrBase64.split(",")[1],
        extension: "png",
      });

      // Fix position → stays inside row
      worksheet.addImage(imageId, {
        tl: { col: 2, row: rowNumber - 1 + 0.1 }, // top left inside row
        ext: { width: 90, height: 90 }, // QR size
      });

      // Add borders
      [1, 2, 3].forEach((c) => {
        const cell = worksheet.getCell(rowNumber, c);
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });
    }

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Download Excel file
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Cards_${startNo || "All"}_to_${endNo || "All"}.xlsx`;
    link.click();
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }
};
